import { render, staticRenderFns } from "./DoctorDetailsModal.vue?vue&type=template&id=211e7a4b&"
import script from "./DoctorDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DoctorDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports